export default __webpack_public_path__ + "static/media/premium_female@3x.6cdc9925.png";